export const COOKIECONSENT__PROVIDER_CREATE = '49E4E631-09C7-49E1-BBD1-77005089C051';
export const COOKIECONSENT__SITES_CREATE = '138B54D7-33FD-4C40-A4EC-12D533612733';
